import { render, staticRenderFns } from "./DispatchSummaryAssets.vue?vue&type=template&id=143a249b&scoped=true"
import script from "./DispatchSummaryAssets.vue?vue&type=script&lang=js"
export * from "./DispatchSummaryAssets.vue?vue&type=script&lang=js"
import style0 from "./DispatchSummaryAssets.vue?vue&type=style&index=0&id=143a249b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143a249b",
  null
  
)

export default component.exports